import { Group, MantineComponent, Stack, Box } from '@mantine/core'
import { ReactNode } from 'react'
import { H2, cn, ActionItem } from '@packages/ui'
export type PageContentShadeProps = MantineComponent<any> & {
  title?: string
  actionItems?: ReactNode[]
  actionItemsGroupedIcon?: ReactNode
  actionItemsGroup?: ActionItem[] | ActionItem[][]
  responsive?: boolean
  disabled?: boolean
  opacity?: number
}

export const PageContentShade = ({
  title,
  actionItems,
  className,
  responsive = true,
  disabled = false,
  onClick: onClickAction,
  dark,
  opacity = 50,
  ...props
}: PageContentShadeProps) => {
  return (
    <Stack
      {...props}
      className={cn(
        'ui-content-shade',
        responsive && 'lg:p-6 xl:px-9',
        !disabled ? 'w-full rounded-lg p-3' : 'bg-transparent!',
        className
      )}
    >
      {title || actionItems ? (
        <Group className={'my-2 justify-between align-top'}>
          <Box>
            {title && (
              <H2
                onClick={onClickAction}
                className={'text-shell-foreground py-0 text-xl sm:text-2xl!'}
              >
                {title}
              </H2>
            )}
          </Box>

          {actionItems}
        </Group>
      ) : null}

      {props.children}
    </Stack>
  )
}
